class UiNodePowerConfigurationsController

  @updateOptionsForConfiguration: (url, selectors) ->
    old_mainboard = selectors['old_mainboard']
    mainboard = selectors['mainboard']
    power_source_a = selectors['power_source_a']
    power_source_b = selectors['power_source_b']

    $(old_mainboard).val($(mainboard).val()) if $(old_mainboard).val() == ''
    $.ajax({
      url: url,
      data: 'new_mainboard_id=' + $(mainboard).val() + '&power_source_a=' + $(power_source_a).val() + '&mainboard_id=' + $(old_mainboard).val(),
      dataType: 'script'
    })

    $(old_mainboard).val($(mainboard).val())

    if $(mainboard).val() == ''
      $(power_source_a).prop('disabled', true)
    else
      $(power_source_a).prop('disabled', false)

    if $(power_source_a).val() == ''
      $(power_source_b).prop('disabled', true)
    else
      $(power_source_b).prop('disabled', false)

module.exports = UiNodePowerConfigurationsController
